import {useTranslation} from "ni18n";
import React, {useEffect, useState} from "react";

interface SearchFilterProps {
  searchText: string;
  // @ts-expect-error TS7010: 'setSearchText', which lacks return-type annotation, implicitly has an 'any' return type.
  setSearchText(text: string);
  isExpanded: boolean;
}

const SearchFilter: React.FC<SearchFilterProps> = ({
  searchText = "",
  setSearchText,
  isExpanded = false,
}) => {
  const i18n = useTranslation();

  const [_isExpanded, setIsExpanded] = useState(isExpanded);

  useEffect(() => {
    setIsExpanded(isExpanded);
  }, [isExpanded]);

  return (
    <div
      data-testid="search-filter"
      role="search"
      className="df aic ass bg-gray100 br8 mb8 contrast-tb"
    >
      <button
        aria-label={_isExpanded ? i18n.t("Hide Search") : i18n.t("Show Search")}
        style={{height: 46, width: 46}}
        className="br50 bg-gray100 brdn contrast-tb"
        onClick={() => setIsExpanded(!_isExpanded)}
        aria-expanded={_isExpanded}
      >
        <span aria-hidden className="cIcon-search fs22 gray800" />
      </button>
      {_isExpanded && (
        <input
          placeholder={i18n.t("Find a service...")}
          className="br8 pv2 pr1 bg-gray100 font-ir brdn contrast-tb"
          value={searchText}
          type="text"
          onChange={e => setSearchText(e.target.value)}
          aria-label={i18n.t("Search prices")}
        />
      )}
    </div>
  );
};

export default SearchFilter;
